import React from 'react';
import './components.css'

const Loader = () => {
  return (
    <div className="loader-container text-center">
      <img src="/assets/images/loader.gif" alt="Loader" />
    </div>
  );
};

export default Loader;
